"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Marc L.",
  quote: "L'expertise de Henintsoa en SEO a littéralement transformé notre visibilité organique. Un stratège digital hors pair.",
  position: "Directeur Marketing",
  avatar: "https://xn--hents-5ua.com/wp-content/uploads/2026/04/Design-sans-titre.webp?v=s6lwpjxgsze"
}, {
  author: "Sophie R.",
  quote: "Grâce à l'automatisation mise en place par Smilegeeks, nous avons gagné 15 heures de travail par semaine. Impressionnant.",
  position: "Fondatrice Tech-Start",
  avatar: "https://xn--hents-5ua.com/wp-content/uploads/2026/04/Gemini_Generated_Image_g6143fg6143fg614-1.png?v=o25pgb6xqzk"
}, {
  author: "François Durnez",
  quote: "L’équipe de rêve sur laquelle s’appuyer pour son marketing et les actions de prospection »",
  position: "",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/image.png"
}, {
  author: "Julie M.",
  quote: "L'accompagnement sur l'IA a ouvert des perspectives incroyables pour notre service client.",
  position: "Responsable Innovation",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/innovation_expert_avatar.png"
}, {
  author: "Yann Rousselain",
  quote: "Réactif, Professionnel, et à l'écoute",
  position: "",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/image.png"
}];
export default function FureverStories() {
  return <section data-section-id="235172" id="échos-de-réussite" className="py-24 md:py-32 bg-background text-foreground overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-[120px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[40%] rounded-lg bg-secondary/10 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10">
        <div className="mb-16 md:mb-24 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tighter uppercase">
            Échos de Réussite
          </h2>
          <div className="h-px w-24 bg-primary mx-auto md:mx-0" />
        </div>

        <Carousel opts={{
        loop: true,
        align: "start",
        duration: 40
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="animate-in fade-in zoom-in-95 duration-700">
                <div className="flex flex-col justify-between h-full p-8 md:p-16 bg-card/30 backdrop-blur-xl rounded-3xl border border-primary/20 shadow-2xl relative overflow-hidden group transition-colors duration-500 hover:border-primary/40">
                  {}
                  <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.1)_50%)] bg-[length:100%_4px] pointer-events-none opacity-20 z-0" />
                  
                  <Quote className="absolute top-8 left-8 w-32 h-32 text-primary/5 -z-10 rotate-180 transition-transform duration-700 group-hover:scale-110" />

                  <div className="relative z-10">
                    <div className="flex gap-1.5 mb-10">
                      {[...Array(5)].map((_, starIdx) => <Star key={starIdx} data-index={starIdx} className="w-6 h-6 fill-primary text-primary" />)}
                    </div>
                    <blockquote className="text-3xl md:text-5xl font-serif italic text-foreground leading-tight md:leading-snug mb-16 max-w-4xl">
                      "{testimonial.quote}"
                    </blockquote>
                  </div>

                  <div className="flex items-center gap-6 relative z-10">
                    <SafeHydrate><Avatar className="size-24 rounded-lg border-2 border-primary transition-all duration-500 group-hover:scale-110 group-hover:shadow-[0_0_25px_rgba(0,240,255,0.6)]">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                      <AvatarFallback className="font-default text-xl bg-secondary text-secondary-foreground rounded-lg">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <div className="font-default font-semibold text-xl text-foreground mb-1">
                        {testimonial.author}
                      </div>
                      <div className="text-base text-muted-foreground font-mono tracking-wider uppercase">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex justify-end gap-4 mt-10 md:mt-12 pr-4 md:pr-8">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-14 rounded-lg border-white/10 bg-card/50 backdrop-blur-md hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-xl" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-14 rounded-lg border-white/10 bg-card/50 backdrop-blur-md hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-xl" />
          </div>
        </Carousel>
      </div>
    </section>;
}